// extracted by mini-css-extract-plugin
export default {"logo":"flight_logo__Vv5yT","number":"flight_number__F2oby","company":"flight_company__91qO4","airport":"flight_airport__9+c+y"};